import { reactive, inject, computed } from 'vue'

export const usersSymbol = Symbol('users')
export const createUsersState = () => {
  const state = reactive({
    user: null,
    isFetchingUser: true,
    isAuthorized: computed(() => state.user && !state.isFetchingUser),
    isUnauthorized: computed(() => !state.user && !state.isFetchingUser),
  })

  return state
}

export const useUsersStore = () => inject(usersSymbol)
